export enum ApiEndpoint {
    Verification = '/verification',
    Registration = '/registration',
    ContractDetails = '/contract/details'
}